/**
 * Cierre de PWA SoftPhone (Android / Chrome / iOS).
 *
 * Realidad de plataforma:
 * - window.close() casi nunca cierra PWA abierta por notificación.
 * - history.go/back PROGRAMÁTICO no cierra la Activity; además puede
 *   restaurar bfcache (Video/timbre) → eso rompía el “back”.
 * - Cierre real en Android: back físico con historial sin entradas previas de la app.
 * - iPhone: no hay back de sistema equivalente; el usuario cierra desde multitarea.
 *
 * No usar about:blank (lleva a Login/huella/grilla).
 */

export function tryClosePwaWindow(): void {
  try {
    window.close();
  } catch {
    /* ignore */
  }
}

/**
 * Sustituye la entrada actual del historial (p. ej. Video+timbre) para que
 * el back físico no restaure la cámara en fullscreen.
 */
export function replaceHistoryForCallEnded(): void {
  try {
    const path = window.location.pathname || '/pwa/';
    const url = `${path}?softphone_ended=1`;
    window.history.replaceState({ shcSoftphoneCallEnded: 1 }, '', url);
  } catch {
    /* ignore */
  }
}

/** Gesto del usuario en Colgar / Cerrar: solo close (sin manipular history hacia atrás). */
export function requestClosePwaFromUserGesture(): void {
  tryClosePwaWindow();
}
